type DirectusError = {
    message?: string;
    extensions?: { code?: string };
};

type ErrorWithResponse = {
    response?: { data?: unknown };
};

export const FALLBACK_LOGIN_ERROR_MESSAGE = "Não foi possível entrar. Tente novamente.";

const readDirectusErrors = (error: unknown) => {
    const responseData = (error as ErrorWithResponse | undefined)?.response?.data as { errors?: unknown } | undefined;
    const directusErrors: Array<DirectusError> = Array.isArray(responseData?.errors) ? responseData?.errors ?? [] : [];
    return directusErrors;
};

export const getLoginErrorMessages = (error: unknown) => {
    const directusMessages = readDirectusErrors(error)
        .map((directusError) => directusError.message)
        .filter((message): message is string => typeof message === "string" && message.length > 0);
    const messages = directusMessages.length > 0 ? directusMessages : [FALLBACK_LOGIN_ERROR_MESSAGE];
    return messages;
};

export const getLoginErrorCode = (error: unknown) => {
    const errorCode = readDirectusErrors(error)[0]?.extensions?.code;
    return errorCode;
};

export const toFinanceLoginError = (financeError: unknown) => {
    const financeErrors = getLoginErrorMessages(financeError).map((message) => ({ message: `Finance: ${message}` }));
    const financeLoginError = { response: { data: { errors: financeErrors } } };
    return financeLoginError;
};
